import { useState } from "react";
import { Stack } from "@altimateai/lego";
import { Input } from "@altimateai/lego";
import { IconSearch } from "@tabler/icons-react";
import KnowledgeBaseSources from "./KnowledgeBaseSources";
import KnowledgeBaseTemplates from "./KnowledgeBaseTemplates";

export default function DocumentsList() {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <Stack direction="column" gap="md">
      {/* Search */}
      <div className="al-relative al-max-w-sm">
        <Input
          type="search"
          placeholder="Search for a document"
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          className="al-pl-9"
        />
        <IconSearch className="al-absolute al-left-3 al-top-1/2 -al-translate-y-1/2 al-h-4 al-w-4 al-text-gray-500 al-pointer-events-none" />
      </div>

      {/* Knowledge Base Sources and Templates */}
      <KnowledgeBaseSources searchQuery={searchQuery} />
      <KnowledgeBaseTemplates searchQuery={searchQuery} />
    </Stack>
  );
}
